import React from 'react'
import BaseMenu, { MenuProps as BaseMenuProps, menuClasses } from '@mui/material/Menu'
import styled from 'particles/themes/styled'
import { BaseMenuItemProps } from 'particles/MenuItem'

type MenuSize = 'm' | 's'

const sizeMap: Record<MenuSize, { border: string; maxHeight: string }> = {
    m: {
        border: '12px',
        maxHeight: '360px',
    },
    s: {
        border: '8px',
        maxHeight: '248px',
    },
}

export interface MenuProps extends BaseMenuProps {
    size?: MenuSize
    maxHeight?: number
    width?: number | string
}

const StyledMenu = styled(BaseMenu)<MenuProps>`
    & .${menuClasses.paper} {
        box-sizing: border-box;
        min-width: 100px;
        align-items: flex-start;
        border-radius: 4px;
        background: ${({ theme }) => theme.colors.surface.primary};
        box-shadow: ${({ theme }) => theme.shadows.level3};
        width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width)};
        max-height: ${({ size, maxHeight }) => (maxHeight ? `${maxHeight}px` : sizeMap[size ?? 's'].maxHeight)};
        border: ${({ theme, size }) => `${sizeMap[size ?? 's'].border} solid ${theme.colors.surface.primary}`};
        // Space between trigger and menu
        margin-top: 4px;
        & .${menuClasses.list} {
            padding: 0;
            display: flex;
            flex-direction: column;
            gap: ${({ theme }) => theme.spacing[100]};
        }
        ::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 5px;
        }
        ::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background-color: ${({ theme }) => theme.colors.surface.neutralActionHover};
        }
    }
`

const Menu: React.FC<MenuProps> = ({ size = 's', children, ...props }) => (
    <StyledMenu {...props} autoFocus={false} size={size}>
        {React.Children.map(children, (child: React.ReactNode) => {
            if (React.isValidElement<BaseMenuItemProps>(child)) {
                return React.cloneElement(child, {
                    size,
                })
            }
            return child
        })}
    </StyledMenu>
)

export default Menu
